import React from "react";
import {
  ArrayField,
  Datagrid,
  TextField,
  BooleanField,
  SelectField,
} from "react-admin";
import { useStatusChoices } from "../Constant/Status";
import {
  ShowMod,
  TabbedShowLayoutMod,
  TabMod,
} from "Component/Redesign/Show/index";
import {
  TextFieldMod,
  EmailFieldMod,
  StatusField,
  DateFieldMod,
} from "Component/Layouts/Field/index";
import { PetType } from "../Constant/PetType";
import { NoResults } from "Component/NoResults/NoResults";
import { PhotoField } from "../PhotoField";

const PostShowActions = () => <div></div>;

export const UserShow = ({ permissions, ...props }) => {
  return (
    <ShowMod {...props} actions={<PostShowActions />}>
      <TabbedShowLayoutMod>
        <TabMod label="resources.admins.tabs.information">
          {/* <TextFieldMod source="id" sortBy="id" /> */}
          <TextFieldMod source="name" />
          <EmailFieldMod source="email" />
          <StatusField
            source="status"
            statusList={useStatusChoices()}
            style={{ width: "10%" }}
          />
          <BooleanField source="isBlackList" />
          <DateFieldMod
            source="createdAt"
            options={{ day: "2-digit", month: "2-digit", year: "numeric" }}
          />
          <DateFieldMod
            label="resources.users.fields.subscriptionPublic"
            source="subscriptionPublic.startAt"
          />
          <DateFieldMod
              label="resources.users.fields.subscriptionPrivate"
              source="subscriptionPrivate.startAt"
          />
          <ArrayField source="pets">
            <Datagrid bulkActionButtons={false} rowClick={false} empty={<NoResults />}>
              {/* <TextField label="resources.pets.fields.id" source="id" /> */}
              <TextField label="resources.pets.fields.name" source="name" />
              <SelectField
                label="resources.pets.fields.petType"
                source="petType"
                choices={PetType}
              />
              <TextField label="resources.pets.fields.breed" source="breed" />
              <TextField label="resources.pets.fields.gender" source="gender" />
              <TextField label="resources.pets.fields.weight" source="weight" />
              <DateFieldMod
                label="resources.pets.fields.birtDate"
                source="birtDate"
                options={{ day: "2-digit", month: "2-digit", year: "numeric" }}
              />
              <PhotoField />
            </Datagrid>
          </ArrayField>
        </TabMod>
      </TabbedShowLayoutMod>
    </ShowMod>
  );
};
